import 'whatwg-fetch'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import createStore from './store'
import VTooltip from 'v-tooltip'
import Icon from '@/components/Icon.vue'
import CURRENT_LANGUAGE_LOCALE_STORAGE_KEY from './store'
import { messages } from './translations'
import store from './store'

Vue.config.productionTip = false

Vue.use(VTooltip)
Vue.use(VueI18n)

Vue.component('Icon', Icon)

const vueStore = createStore(router);
const i18n = new VueI18n({
  locale: vueStore.state.currentLanguage || 'en',
  fallbackLocale: 'en',
  messages
})

new Vue({
  i18n,
  router,
  store: vueStore,
  render: createElement => createElement(App)
}).$mount('#app')
